<div class="card margin-bottom-lg shadow-none">
  <div class="card-header">
    <h1>
      {{ 'findings_details' | translate }}
      @if (scanIssues) {
        <small class="ps-2">{{ 'label_total_findings' | translate: scanIssues[$scanIssues.totalIssues] }}</small>
      }
      @if (!scanIssues && scanRule) {
        <small class="ps-2">{{ 'label_total_findings' | translate: scanRule[$scanIssues.totalIssues] }}</small>
      }
    </h1>
  </div>
  <div class="card-body text-black h-100">
    @if (scanIssues) {
      <app-issues-view-rule-info class="col-12 margin-bottom-md" [scanIssues]="scanIssues"></app-issues-view-rule-info>
    }
    @if (!scanIssues && scanRule) {
      <app-issues-view-rule-info class="col-12 margin-bottom-md" [scanIssues]="scanRule"></app-issues-view-rule-info>
    }
    @if (advancedFilter) {
      <app-issues-advanced-search
        class="col-12 margin-bottom-md"
        [initialRows]="advancedFilter"
        (onApply)="onAdvancedSearch($event)"
      ></app-issues-advanced-search>
    }
    @if (!supplementalScanError) {
      @if (!isFindingScanProcessing) {
        @if (scanIssues.totalIssues > 0) {
          <div class="container-fluid">
            <div class="top-border row">
              <div [class]="findingsDetailsRefreshFF() ? 'col-12' : 'col-lg-8 table-section'">
                @if (scanIssues) {
                  <app-issues-view-table-actions
                    [scanIssues]="scanIssues"
                    [scanId]="scanId"
                    [scanUrl]="scanUrl"
                    [auditType]="auditType"
                    [ruleId]="ruleId"
                    [selectedIssues]="selectedIssues"
                    [filterByActivity]="filterDismissed"
                    (filterByActivityChange)="onFilterByActivity($event)"
                    (onIssueChangeSuccess)="reloadReport({ task: $event })"
                    (bannerStatusEvent)="updateBannerStatus($event)"
                  ></app-issues-view-table-actions>
                }
                <app-issues-view-banner
                  [bannerStatus]="bannerStatus"
                  [(showBanner)]="showBanner"
                  [taskLink]="taskLink"
                  [taskProjectId]="taskProjectId"
                ></app-issues-view-banner>
                @if (findingsDetailsRefreshFF()) {
                  <div class="overflow-auto">
                    <ds-table-component
                      [columns]="dsTableConfig.columns"
                      [data]="dsTableData ?? []"
                      [caption]="dsTableConfig.tableCaption"
                      [emptyText]="'no_search_results_available' | translate"
                      [selectAllEnabled]="true"
                      [manualSorting]="true"
                      [selectAllCheckboxLabel]="dsTableConfig.selectAllCheckboxLabel"
                      [rowCheckboxLabel]="dsTableConfig.rowCheckboxLabel"
                      [checkboxCellKey]="dsTableCheckboxCellKey"
                      [selectedRowKeys]="(selectedIssueKeys$ | async) ?? []"
                      (onSort)="applySort($event)"
                      (selectedRowKeysChange)="onDsTableSelectedRowKeysChange($event)"
                    ></ds-table-component>
                  </div>
                } @else {
                  <div class="margin-bottom">
                    @if (tableData && (tableConfig$ | async)) {
                      <app-ngb-table
                        [config]="tableConfig$ | async"
                        [sortingOrder]="tableSortingOrder"
                        [data]="tableData"
                        [rowSelectionIndex]="rowSelectionIndex"
                        [allSelected]="allPageSelected$ | async"
                        (onSelectAll)="onSelectAll($event)"
                        (onSort)="onSort($event)"
                        (rowSelectionChange)="onRowSelected($event)"
                        #issuesTable
                      ></app-ngb-table>
                    }
                  </div>
                }
                @if (tableData) {
                  @if (findingsDetailsRefreshFF()) {
                    <div>
                      <ds-pagination-v2
                        [ariaLabel]="dsTableConfig.tableCaption"
                        [page]="currentPage"
                        [pageSize]="entriesPerPage"
                        [collectionSize]="filteredIssues.length"
                        [paginationForTable]="true"
                        (pageChange)="onPageChange($event)"
                        (pageSizeChange)="onEntriesPerPageChange($event)"
                      ></ds-pagination-v2>
                    </div>
                  } @else {
                    <div class="d-flex justify-content-end align-items-end flex-column-reverse flex-md-row align-items-md-center">
                      <app-responsive-pagination
                        [page]="currentPage"
                        (pageChange)="onPageChange($event)"
                        [pageSize]="entriesPerPage"
                        (pageSizeChange)="onEntriesPerPageChange($event)"
                        [collectionSize]="filteredIssues.length"
                        [entryLimits]="entriesLimits"
                      >
                      </app-responsive-pagination>
                    </div>
                  }
                }
              </div>
              @if (!findingsDetailsRefreshFF()) {
                <div id="issueDetailsPanel" tabindex="-1" class="col-lg-4 details-section">
                  @if (selectedIssue) {
                    <app-issues-view-details
                      class="d-block margin-top-lg"
                      [toolName]="toolName"
                      [scanId]="scanId"
                      [issue]="selectedIssue"
                      [ruleDetails]="scanIssues"
                      [isDigitalAssetFindingsEnabled]="isDigitalAssetFindingsEnabled$ | async"
                    >
                    </app-issues-view-details>
                  }
                  @if (selectedIssue) {
                    <ds-link standalone="true" skip="true" [href]="getSelectedIssueBtnSelector">
                      {{ 'back_to_findings' | translate }}
                    </ds-link>
                  }
                </div>
              }
            </div>
          </div>
        } @else {
          <div id="no-findings-to-show-state" class="container-fluid">
            <div class="row">
              <div class="col top-border">
                <table-empty-state
                  [config]="{
                    iconId: 'empty-box',
                    title: 'no_findings_to_show' | translate,
                    subtitle: 'no_findings_to_show_for_rule_in_scan_subtitle' | translate,
                  }"
                ></table-empty-state>
              </div>
            </div>
          </div>
        }
      } @else {
        <div id="finding-scan-processing-state" class="info-container padding-top-lg col">
          <p class="info-title margin-top-lg padding-bottom-lg">{{ 'scanning_page...' | translate }}</p>
          <app-common-spinner class="padding-bottom-lg" [size]="59"></app-common-spinner>
          <p class="info-subtitle padding-bottom-lg">{{ processingMessage }}</p>
          @if (requestScanId !== scanId) {
            <button class="btn btn-outline-primary margin-right-sm" type="button" (click)="goBack()">
              {{ 'back_to_page_report' | translate }}
            </button>
          }
        </div>
      }
    } @else {
      <div id="scan-error-state" class="container-fluid">
        <div class="row">
          <div class="col top-border">
            @if (requestScanId === scanId) {
              <table-empty-state
                [config]="{
                  iconId: 'clipboard-red',
                  title: 'no_scan_results_available' | translate,
                  subtitle: 'no_scan_results_available_for_findings_details_subtitle' | translate,
                  iconFill: 'none',
                }"
              ></table-empty-state>
            } @else {
              <table-empty-state
                [config]="{
                  iconId: 'clipboard-red',
                  title: 'no_scan_results_available' | translate,
                  subtitle: supplementalScanError.error,
                  iconFill: 'none',
                }"
              ></table-empty-state>
              @if (supplementalScanError.isRetryable === true) {
                <div class="col-12 d-flex flex-column justify-content-center align-items-center">
                  <button class="btn btn-primary margin-right-md" type="button" (click)="restartSupplementalScan()">
                    {{ 'try_again' | translate }}
                  </button>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #changesNotification>
  <div>{{ 'label_toast_please_reload_to_most_updated' | translate }}</div>
  <a (click)="reloadReport({ clearNotifications: true })">{{ 'label_reload_page' | translate }}</a>
</ng-template>
